import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { GRADIENT_CONTRACT, MEMELAB_CONTRACT, MEMES_CONTRACT, NEXTGEN_CONTRACT } from "@/constants/constants";
import { ApiGroupOwnsNftNameEnum } from "@/generated/models/ApiGroupOwnsNft";
import type { ApiNftsPage } from "@/generated/models/ApiNftsPage";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
export default function GroupCreateNftsSelectedItem(t0) {
  const $ = _c(29);
  const {
    nft,
    onRemove
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiGroupOwnsNftNameEnum.Gradients]: GRADIENT_CONTRACT,
      [ApiGroupOwnsNftNameEnum.Memelab]: MEMELAB_CONTRACT,
      [ApiGroupOwnsNftNameEnum.Nextgen]: NEXTGEN_CONTRACT,
      [ApiGroupOwnsNftNameEnum.Memes]: MEMES_CONTRACT
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const NAME_TO_CONTRACT_MAP = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [ApiGroupOwnsNftNameEnum.Gradients]: "Gradients",
      [ApiGroupOwnsNftNameEnum.Memelab]: "Memelab",
      [ApiGroupOwnsNftNameEnum.Nextgen]: "NextGen",
      [ApiGroupOwnsNftNameEnum.Memes]: "The Memes"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const NAME_TO_NAME_MAP = t2;
  const t3 = NAME_TO_CONTRACT_MAP[nft.name];
  let t4;
  if ($[2] !== nft.token || $[3] !== t3) {
    t4 = [QueryKey.NFTS, {
      contract: t3,
      id: nft.token
    }];
    $[2] = nft.token;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== nft.name || $[6] !== nft.token) {
    t5 = async () => await commonApiFetch({
      endpoint: "nfts",
      params: {
        contract: NAME_TO_CONTRACT_MAP[nft.name],
        id: nft.token
      }
    });
    $[5] = nft.name;
    $[6] = nft.token;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = {
      queryKey: t4,
      queryFn: t5
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const {
    data
  } = useQuery(t6);
  let t7;
  if ($[11] !== data) {
    t7 = <div className="tw-relative tw-h-7 tw-w-7 tw-flex-shrink-0 tw-rounded-sm tw-border tw-border-solid tw-border-white/10 tw-bg-iron-800"><div className="tw-h-full tw-w-full tw-max-w-full tw-overflow-hidden tw-rounded-sm tw-bg-iron-800"><div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-sm tw-text-center">{data?.data?.[0]?.image ? <img src={getScaledImageUri(data.data[0].image, ImageScale.W_AUTO_H_50)} alt={data.data[0].name} className="tw-h-full tw-w-full tw-object-contain" /> : <div className="tw-h-full tw-w-full tw-bg-iron-900" />}</div></div></div>;
    $[11] = data;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = data?.data?.[0]?.name;
  let t9;
  if ($[13] !== t8) {
    t9 = <span className="tw-text-xs tw-font-semibold tw-text-iron-50">{t8}</span>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="tw-h-1 tw-w-1 tw-rounded-full tw-bg-iron-600" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = NAME_TO_NAME_MAP[nft.name];
  let t12;
  if ($[16] !== t11) {
    t12 = <span className="text-xs tw-font-medium tw-text-iron-300">{t11}</span>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t7 || $[20] !== t9) {
    t13 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-py-1">{t7}{t9}{t10}{t12}</div>;
    $[18] = t12;
    $[19] = t7;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="tw-sr-only">Remove</span>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-size-4 tw-flex-shrink-0"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== onRemove) {
    t16 = <button type="button" onClick={onRemove} className="tw-group tw-relative -tw-mr-1.5 tw-flex tw-h-full tw-items-center tw-justify-center tw-border-y-0 tw-border-l tw-border-r-0 tw-border-solid tw-border-iron-700 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-300 tw-ease-out hover:tw-text-error">{t14}{t15}</button>;
    $[24] = onRemove;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t13 || $[27] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-gap-x-3 tw-rounded-lg tw-bg-iron-950 tw-px-2 tw-text-xs tw-font-medium tw-ring-1 tw-ring-inset tw-ring-iron-700">{t13}{t16}</div>;
    $[26] = t13;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
}